export const API_CLIENT_COMMUNICATION_SUCCESS = 'communication_success';
export const API_CLIENT_COMMUNICATION_FAILURE = 'communication_failure';

/** @type {((event: typeof API_CLIENT_COMMUNICATION_SUCCESS | typeof API_CLIENT_COMMUNICATION_FAILURE) => void) | null} */
let communicationListener = null;

const CONNECTION_ERROR_CODES = new Set([
  'ECONNREFUSED',
  'ENOTFOUND',
  'ECONNRESET',
  'ETIMEDOUT',
  'EAI_AGAIN',
  'ECONNABORTED',
  'ERR_CONNECTION_REFUSED',
  'ERR_NETWORK',
  'ERR_INTERNET_DISCONNECTED',
  'ERR_NAME_NOT_RESOLVED'
]);

/**
 * Register a global listener for ApiClient communication outcomes.
 */
export function setApiClientCommunicationListener(listener) {
  communicationListener = listener;
}

export function notifyApiClientCommunication(event) {
  communicationListener?.(event);
}

/**
 * @param {import('superagent').ResponseError | Error | null | undefined} err
 */
export function isApiConnectionError(err) {
  if (!err) {
    return false;
  }

  if (err.aborted === true || err.code === 'ABORTED') {
    return false;
  }

  // Superagent sets crossDomain for browser status-0 failures (CORS, offline, unload).
  // These are not reliable connectivity signals for a single API call.
  if (err.crossDomain === true) {
    return false;
  }

  const status = err.status;

  if (typeof status === 'number' && status >= 400) {
    return false;
  }

  const code = err.code;
  if (isKnownConnectionErrorCode(code)) {
    return true;
  }

  if (err.timeout === true) {
    return true;
  }

  if (status === 0) {
    return true;
  }

  if (status == null && err.response == null) {
    return true;
  }

  return false;
}

function isKnownConnectionErrorCode(code) {
  return typeof code === 'string' && CONNECTION_ERROR_CODES.has(code);
}

/**
 * For RTK rejected `action.error` — only name/message/stack/code survive.
 * Use explicit transport signals; never treat "missing status" as offline.
 *
 * @param {unknown} error
 */
export function isSerializedConnectionFailure(error) {
  if (!error || typeof error !== 'object') {
    return false;
  }

  const { code, message } = error;
  if (isKnownConnectionErrorCode(code)) {
    return true;
  }

  if (typeof message !== 'string') {
    return false;
  }

  return (
    message.includes('Failed to fetch') ||
    message.includes('Request has been terminated')
  );
}
